import { Panel } from "../../../components/panels/Panel";
import { formatSecondsToFullDateTime } from "../../../helpers/date/date-helper";
import { DateRangePickerComponent } from "../../../components/others/DateRangePickerComponent";
import { ActionButton } from "../../../components/buttons/ActionButton";
import { ClockIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { getInfluxdbData } from "../../../services/api/influxdb-tools";
import { getRacksTypesCount } from "../../../services/live-interface/dior/dior-interface-service";


export const DiorDashboardDataPage = () => {

  /* Dates management */
  const now = new Date();
  const defaultStart = new Date(now);
  defaultStart.setHours(0, 0, 0, 0);
  const defaultEnd = new Date(now);
  defaultEnd.setHours(23, 59, 0, 0);

  const [selectedRange, setSelectedRange] = useState({ start: defaultStart, end: defaultEnd });

  const handleRangeSelection = (start, end) => {
    setSelectedRange({ start, end });
    updateData(Math.floor(start / 1000), Math.floor(end / 1000));
  };

  const [racksTypesCountData, setRacksTypesCountData] = useState([]);

  const updateData = async (start, end) => {
    const newRacksTypesCountData = await getInfluxdbData(
      'engine',
      '',
      [],
      [],
      start,
      end,
      '1ms',
      null,
      null,
      [],
      null,
      getRacksTypesCount(),
      false,
      'desc',
    );

    setRacksTypesCountData(newRacksTypesCountData);
  };

  return (
    <Panel category='main' title='DASHBOARD'>
      <div className="h-full flex flex-col gap-4">
        <Panel noHeader category="secondary" rounded height="h-16">
          <div className="flex gap-8 items-center h-full">
            <div className="flex gap-2 items-center">
              <div>Start date</div>
              <div className="bg-perception-black-800 rounded-md px-2 py-1">
                {formatSecondsToFullDateTime(selectedRange.start.getTime() / 1000, false)}
              </div>
            </div>

            <div className="flex gap-2 items-center">
              <div>End date</div>
              <div className="bg-perception-black-800 rounded-md px-2 py-1">
                {formatSecondsToFullDateTime(selectedRange.end.getTime() / 1000, false)}
              </div>
            </div>

            <DateRangePickerComponent
              trigger={({ isCalendarOpen, setIsCalendarOpen }) => (
                <ActionButton text="Select date range" Icon={ClockIcon} size="sm" onClick={() => setIsCalendarOpen(!isCalendarOpen)} />
              )}
              defaultStart={defaultStart} defaultEnd={defaultEnd}
              callback={handleRangeSelection}
              cancelText="Cancel" validateText="Load racks"
            />
          </div>
        </Panel>

        <Panel title="RACKS COUNT" rounded width="w-1/2">
          <table className='w-full'>
            <thead>
            <tr>
              <th className='p-3 text-left bg-perception-gray-800'>Rack type</th>
              <th className='p-3 text-left bg-perception-gray-800'>Count</th>
            </tr>
            </thead>
            <tbody>
            {
              racksTypesCountData.map((rackTypeCount) => (
                <tr>
                  <td className='p-3'>{rackTypeCount.type}</td>
                  <td className='p-3'>{rackTypeCount._value}</td>
                </tr>
              ))
            }
            </tbody>
          </table>
        </Panel>
      </div>
    </Panel>
  );
};